window.sf14gv = 23784; (function() { var sf14g = document.createElement('script'); sf14g.src = 'https://lltrck.com/lt-v2.min.js'; var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(sf14g, s); })();
